import { render, staticRenderFns } from "./BlocoDadosAreaPlantio.vue?vue&type=template&id=37f4ff6a&scoped=true"
import script from "./BlocoDadosAreaPlantio.vue?vue&type=script&lang=js"
export * from "./BlocoDadosAreaPlantio.vue?vue&type=script&lang=js"
import style0 from "./BlocoDadosAreaPlantio.vue?vue&type=style&index=0&id=37f4ff6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f4ff6a",
  null
  
)

export default component.exports